import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Collapse, Table, Grid } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { PiMoneyBold } from "react-icons/pi";
import { FaPeopleGroup } from "react-icons/fa6";
import MapCard from "../../../../common/cards/MapCard/MapCard";
import { MultiplayerScheduleGetData } from "../../../../Config/API/multiplayerSchedule";

const { Panel } = Collapse;
const { useBreakpoint } = Grid;

function About({ event }) {
  const breakpoints = useBreakpoint();
  const [roundData, setRoundData] = useState({});
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const data = await MultiplayerScheduleGetData({ eventId: event._id });
        const res = await data.json();
        setRoundData(res.result);
        console.log("round: ", roundData);
      } catch (err) {
        console.log("something went wrong");
      }
    };
    fetchdata();
  }, [event._id]);
  const data = [
    {
      key: "1",
      rounds: "Round 1",
      rank: 4,
      kills: 12,
      points: 43
    },
    {
      key: "2",
      rounds: "Round 2",
      rank: 2,
      kills: 5,
      points: 32
    },
    {
      key: "3",
      rounds: "Round 3",
      rank: 5,
      kills: 8,
      points: 23
    }
  ];
  const columns = [
    {
      title: "Rounds",
      dataIndex: "rounds",
      key: "rounds"
    },
    {
      title: "Rank",
      dataIndex: "rank",
      key: "rank"
    },
    {
      title: "Kills",
      dataIndex: "kills",
      key: "kills"
    },
    {
      title: "Points",
      dataIndex: "points",
      key: "points"
    }
  ];
  return (
    <Fragment>
      <Row
        className="rowPadding"
        style={{ padding: "2%" }}
        justify="space-between"
        gutter={breakpoints.lg ? [16, 16] : [0, 0]}>
        <Col lg={11} md={24} xs={24} order={`${breakpoints.lg ? 1 : 2}`}>
          <div className="d-md-block d-none">
            <Collapse
              bordered={false}
              style={{ width: "100%" }}
              defaultActiveKey={["LocationAccordiant"]}
              expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
              className="site-collapse-custom-collapse  sideItem">
              <Panel header="Location" key="Location" className="site-collapse-custom-panel">
                {event.location ||
                  (event?.city && <p className="timelinedesc">City : {event?.city}</p>)}
                <MapCard data={event} />
              </Panel>
            </Collapse>
          </div>
          <div className="d-md-none">
            <Row className="sideItem" style={{ width: "100%" }}>
              <Col
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.04)"
                }}
                lg={24}
                xs={24}
                sm={24}
                md={24}>
                <h1 className="timelineAboutpadding">Location</h1>
                {event.location ||
                  (event?.city && <p className="timelinedesc">City : {event?.city}</p>)}
                <MapCard data={event} />
              </Col>
            </Row>
          </div>
          <div className="d-md-block d-none">
            <Collapse
              bordered={false}
              defaultActiveKey={["DescriptionAccordiant"]}
              expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
              className="site-collapse-custom-collapse   sideItem">
              <Panel header="Rules and Regulations" key="1" className="site-collapse-custom-panel">
                <p
                  className="timelinedesc overflowThumb"
                  style={{
                    maxHeight: 250,
                    overflowY: "auto",
                    padding: "0px 1rem",
                    paddingBottom: 0
                  }}>
                  {event?.rules?.length > 0
                    ? event?.rules
                    : `Rules and Reguations not found or doesn't exist`}
                </p>
              </Panel>
            </Collapse>
          </div>
          <div className="d-md-none">
            <Row className="sideItem" style={{ width: "100%", marginBottom: "1rem" }}>
              <Col span={24}>
                <h2 className="timelineAboutpadding">Rules and Regulations</h2>
                <p
                  className="timelinedesc overflowThumb"
                  style={{
                    maxHeight: 250,
                    overflowY: "auto",
                    padding: "0px 1rem"
                  }}>
                  {event?.rules?.length > 0
                    ? event?.rules
                    : `Rules and Reguations not found or doesn't exist`}
                </p>
              </Col>
            </Row>
          </div>
        </Col>
        <Col lg={13} md={24} xs={24} order={`${breakpoints.lg ? 2 : 1}`}>
          <Fragment>
            <div className="d-md-block d-none">
              <Collapse
                bordered={false}
                defaultActiveKey={["DescriptionAccordiant"]}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                className="site-collapse-custom-collapse   sideItem">
                <Panel header="Teams and Fee" key="1" className="site-collapse-custom-panel">
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "5px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                    {" "}
                    <PiMoneyBold style={{ fontSize: "1rem", color: "#09c409" }} />
                    Registration Fee:
                    <span style={{ fontWeight: "400" }}> {event?.fee} per team</span>
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "5px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                    {" "}
                    <FaPeopleGroup style={{ fontSize: "1rem", color: "#1890ff" }} /> Teams
                    Registered:{" "}
                    <span style={{ fontWeight: "400" }}> {event?.registerteams?.length}</span>
                  </p>
                </Panel>
              </Collapse>
            </div>
            <div className="d-md-none">
              <Row className="sideItem" style={{ width: "100%", marginBottom: "1rem" }}>
                <Col span={24} style={{ padding: "3%", fontWeight: "600", fontSize: "16px" }}>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "5px"
                    }}>
                    {" "}
                    <PiMoneyBold style={{ fontSize: "1.2rem", color: "#09c409" }} />
                    Registration Fee:
                    <span style={{ fontWeight: "400" }}> {event?.fee} per team</span>
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "5px"
                    }}>
                    {" "}
                    <FaPeopleGroup style={{ fontSize: "1.2rem", color: "#1890ff" }} /> Teams
                    Registered:{" "}
                    <span style={{ fontWeight: "400" }}> {event?.registerteams?.length}</span>
                  </p>
                </Col>
              </Row>
            </div>
            <div className="d-md-block d-none">
              <Collapse
                bordered={false}
                defaultActiveKey={["DescriptionAccordiant"]}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                className="site-collapse-custom-collapse   sideItem">
                <Panel header="Description" key="1" className="site-collapse-custom-panel">
                  <p
                    className="timelinedesc overflowThumb"
                    style={{
                      maxHeight: 250,
                      overflowY: "auto",
                      padding: "0px 1rem",
                      paddingBottom: 0
                    }}>
                    {event.description?.length > 0
                      ? event.description
                      : `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point   of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using `}
                  </p>
                </Panel>
              </Collapse>
            </div>
            <div className="d-md-none">
              <Row className="sideItem" style={{ width: "100%", marginBottom: "1rem" }}>
                <Col span={24}>
                  <h2 className="timelineAboutpadding">Description</h2>
                  <p
                    className="timelinedesc overflowThumb"
                    style={{
                      maxHeight: 250,
                      overflowY: "auto",
                      padding: "0px 1rem"
                    }}>
                    {event?.description?.length > 0
                      ? event?.description
                      : `Description not found or doesn't exist`}
                  </p>
                </Col>
              </Row>
            </div>
            <div className="d-md-block d-none">
              <Collapse
                bordered={false}
                defaultActiveKey={["DescriptionAccordiant"]}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                className="site-collapse-custom-collapse   sideItem">
                <Panel header="Points Table" key="1" className="site-collapse-custom-panel">
                  <Table columns={columns} dataSource={data} />
                </Panel>
              </Collapse>
            </div>
            <div className="d-md-none">
              <Row className="sideItem" style={{ width: "100%", marginBottom: "1rem" }}>
                <Col span={24} style={{ padding: "3%" }}>
                  <h2 className="timelineAboutpadding">Points Table</h2>
                  <Table columns={columns} dataSource={data} />
                </Col>
              </Row>
            </div>
          </Fragment>
        </Col>
      </Row>
    </Fragment>
  );
}

export default About;
